/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { TranslateModule } from './../../translate/src/translate.module';
import { InaxTranslateService } from './../../translate/src/translate';
import { MotionUiResourceManager } from './resources/resource.service';
import { MotionComponent } from './motion/motion.component';
import { MotionLineComponent } from './motionLine/motionline.component';
//import { FinalPositionComponent } from './finalPosition/finalPosition.component';
import { MOTION_ROUTES } from './motionUi.routing';
import { CommonUiModule } from '../../commonUi/src/commonUi.module';
import { InaxMotionService } from '../../motion/src/motion';
import { InaxMotionTextsService } from '../../motion/src/motionTexts';
import { InaxMotionTextsPipe } from '../../motion/src/motionTextsPipe';

@NgModule({
    imports:
    [
        //Modules
        BrowserModule,
        FormsModule,
        HttpModule,
        TranslateModule,
        CommonUiModule,
        MOTION_ROUTES
    ],
    exports:
    [
        MotionComponent
    ],
    declarations:
    [
        //Components
        MotionComponent,
        MotionLineComponent,
        InaxMotionTextsPipe
//        FinalPositionComponent
    ],
    providers:
    [
        MotionUiResourceManager,
        InaxMotionService,
        InaxMotionTextsService
    ],
    bootstrap: []
})

export class MotionUiModule {
    //Resource manager adds the translations to the translationservice
    constructor(private _resourceManager: MotionUiResourceManager ) {}
 }